<template>
    <div class="container">
        <section class="cta-section">
            <div class="row">
                <div class="col-12 col-lg-6 text-container">
                    <div class="text-wrapper">
                        <h2>{{ $t('ctaForm.heading') }}</h2>
                        <h3>{{ $t('ctaForm.subHeading') }}</h3>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <form class="row form-container" @submit="submit">
                        <div class="col-12 input-container">
                            <MoneyField
                                name="loanAmount"
                                :label="$t('form.fields.loanAmount.label')"
                                :validationRules="{
                                    amountBetween: {
                                        min: minLoanAmount,
                                        max: maxLoanAmount,
                                        errorMessage: $t('form.fields.loanAmount.amountBetweenErrorMessage'),
                                    },
                                }"
                                :maxlength="9"
                                :min="minLoanAmount"
                                :max="maxLoanAmount"
                                vuexKey="internal"
                            />
                        </div>

                        <div class="col-12 input-container">
                            <input
                                class="button secondary submit-button"
                                type="submit"
                                :value="$t('heroForm.submit')"
                            />
                        </div>

                        <div class="col-12 disclaimer-text">
                            <p class="text-center" v-html="$t('heroForm.notAffectCredit')"></p>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { useForm } from 'vee-validate'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { trackEvent } from '@js/utilities/tracking.js'
import { maxLoanAmount, minLoanAmount } from '@js/utilities/loanDetails.js'

export default {
    setup() {
        const store = useStore()
        const router = useRouter()
        const { validate } = useForm()

        return {
            store,
            router,
            validate,
        }
    },
    methods: {
        submit: async function (e) {
            document.activeElement.blur()
            e.preventDefault()

            const validationResult = await this.validate()

            if (!validationResult.valid) {
                return false
            }

            trackEvent('event', {
                eventCategory: 'form',
                eventAction: 'submit',
                eventLabel: 'homepage-cta-form',
                eventValue: this.loanAmount,
            })

            return this.router.push({
                name: 'apply',
                query: {
                    loan_amount: this.loanAmount,
                },
            })
        },
    },
    computed: {
        maxLoanAmount,
        minLoanAmount,
        loanAmount: function () {
            return this.store.getters.fieldValue('loanAmount', 'internal', true)
        },
        territory: function () {
            return process.env.TERRITORY
        },
        showHomeAndCredit: function () {
            return this.territory != 'pol' && this.territory != 'usa'
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.cta-section {
    background: linear-gradient(180deg, var(--hero-gradient-color-top), var(--hero-gradient-color-bottom));
    border-radius: 8px;
    margin-bottom: 51px;
    padding: 20px 0;

    .text-container {
        align-items: center;
        display: flex;
        justify-content: center;

        h2 {
            color: var(--cta-heading-color);
            font-size: rem(30px);
            font-style: normal;
            font-weight: 600;
        }

        h3 {
            color: var(--cta-sub-heading-color);
            font-size: rem(18px);
            font-weight: normal;
            margin-bottom: 32px;
            text-align: center;

            strong {
                color: #ffffff;
            }
        }

        @media screen and (min-width: $bp-large) {
            justify-content: left;

            .text-wrapper {
                padding-left: 45px;

                h2 {
                    font-size: rem(40px);
                }

                h3 {
                    font-size: rem(19px);
                }
            }
        }
    }
}

.form-container {
    @media screen and (min-width: $bp-large) {
        margin: 0 15px;
        padding: 24px 30px;
    }

    .input-container {
        padding: 0 5px 10px;
    }

    .submit-button {
        border-radius: 4px;
        color: var(--cta-form-button-text-color);
        font-family: var(--heading-font);
        font-size: rem(15px);
        font-weight: bold;
        height: 52px;
        margin: 10px 0px 18px;
        text-align: center;
        transition: all 0.3s;
        width: 100%;

        @media screen and (min-width: $bp-large) {
            margin: 0px;
        }
    }

    .partner-logo {
        max-width: 90px;
    }

    .disclaimer-text {
        text-align: center;
        padding: 0 5px;

        p {
            color: var(--cta-sub-heading-color);
            font-size: rem(11px);
            line-height: 13px;
            margin-bottom: 30px;

            @media screen and (min-width: $bp-large) {
                margin-bottom: 0;
            }
        }

        img {
            margin-bottom: 30px;
        }

        @media screen and (min-width: $bp-large) {
            text-align: left;
        }
    }
}
</style>
